export default __webpack_public_path__ + "static/media/arrow_down.e65aeb2d.svg";